import { ProfileScreen } from '../features/account/ProfileScreen'

export function ProfilePage() {
  return <ProfileScreen />
}
